<template>
  <Common>
    <PageTitle
      title="DeFi Dashboard"
      :description="`Discover DeFi projects within the ${CHAIN} Ecosystem.`"
      class="p-4"
    />
    <Divider />
    <DefiSummary />
    <Divider />
    <DefiList />
  </Common>
</template>

<script setup lang="ts">
import DefiList from '~/components/@pages/defi-dashboard/DefiList.vue'
import DefiSummary from '~/components/@pages/defi-dashboard/DefiSummary.vue'
import { useMeta } from '~/composables/useMeta'
import { CHAIN } from '~/constants/default.constants'
import Common from '~/layouts/common.vue'

useMeta({ title: 'DeFi Dashboard' })
</script>

<style scoped lang="scss">

</style>